import { useEffect, useState, useMemo } from "react";
import { Container, ListGroup, Spinner, Alert } from "react-bootstrap";
import { useNavigate } from "react-router-dom";

import { useTitle } from "./context";
import { fetchSchools, getSchoolIconPath, storeState, loadState } from "./utilities";

import "bootstrap/dist/css/bootstrap.min.css";


const SCHOOLS_PAGE_KEY = "schools-page";


export function SchoolsPage({navbarHeight}) {
    const navigate = useNavigate();
    const { setTitle } = useTitle();
    const [schools, setSchools] = useState([]);
    const [status, setStatus] = useState("idle"); // idle | loading | success | error
    const [error, setError] = useState("");
    
    useEffect(() => {
        setTitle("Scuole");
    }, [setTitle]);
    
    const getStateJson = () => {
        return {
            schools: schools
        };
    };

    const setStateJson = (s) => {
        setSchools(s.schools);
    };
    
    useEffect(() => {
        if (schools && schools.length > 0) {
            storeState(SCHOOLS_PAGE_KEY, getStateJson());
        }
    }, [schools]);
    
    const fetchData = async () => {
        setSchools(await fetchSchools());
    }

    useEffect(() => {
        let mounted = true;
        (
            async () => {
                try {
                    setStatus("loading");
                    const s = loadState(SCHOOLS_PAGE_KEY);
                    if (s?.schools?.length > 0) {
                        setStateJson(s);
                    }
                    else {
                        await fetchData();
                    }
                    if (mounted) {
                        setStatus("success");
                    }
                }
                catch {
                    if (mounted) {
                        setError("Failed to load items.");
                        setStatus("error");
                    }
                }
            }
        )();
        return () => {
            mounted = false;
        };
    }, []);

    const navigateToSchool = (schoolId) => {
        navigate(`/schools/${schoolId}`);
    };

    const content = useMemo(() => {
        if (status === "loading") {
            return (
                <div className="d-flex justify-content-center py-5">
                    <Spinner animation="border" role="status" aria-label="Loading items" />
                </div>
            );
        }
        if (status === "error") {
            return <Alert variant="danger" className="my-3">{error}</Alert>;
        }
        if (schools.length === 0) {
            return <Alert variant="secondary" className="my-3">No schools found.</Alert>;
        }

        //else

        return (
            <ListGroup as="ul" variant="flush" className="shadow-sm bg-white rounded mt-3 mb-3">
                {schools.map((school) => {
                    return (
                        <ListGroup.Item
                        as="li"
                        key={school.id}
                        action
                        onClick={() => navigateToSchool(school.id)}
                        className="d-flex align-items-center gap-3 py-3"
                        role="button"
                        aria-label={`Open ${school.name}`}
                        >
                            <span aria-hidden="true" className="fs-5 d-inline-flex">
                                <img src={getSchoolIconPath(school.name)} style={{width:"40px",height:"40px"}}/>
                            </span>
                            <span className="fw-medium">
                                {school.name}
                            </span>
                        </ListGroup.Item>
                    );
                })}
            </ListGroup>
        );
    }, [status, schools, error, navigate]);

    const containerMargin = `${navbarHeight}px`;
    const containerHeight = `calc(100vh - ${navbarHeight}px)`;

    return (
        <Container
        fluid
        className="bg-light"
        style={{
            marginTop: containerMargin,
            height: containerHeight,
            overflowY: "auto"
        }}
        >
            {content}
        </Container>
    );
}
